import { PlayerNumberToColor } from 'draft/utils/colorUtils'
import React, { useState } from 'react'

import { Grid } from 'semantic-ui-react'
import { useMeleeContext } from '../context/MeleeContextProvider'

import { DraftType, Player } from '../types'

import DuelForm from '../duel/duelForm'

import MeleeDashboard from './meleeDashboard'

type Props = {
    draftType: DraftType;
    setDraftType: (draftType: DraftType) => void;
}

const PlayerForm = ({ draftType, setDraftType }: Props) => {
    const context = useMeleeContext();

    const PlayerField = (props: { player: Player | undefined }) => {
        var player = props.player;

        let initialName = '';
        if (player && player.Name && !player.Name.toLowerCase().includes("player")) {
            initialName = player.Name;
        }

        const [playerNameField, setPlayerNameField] = useState(initialName);

        const UpdatePlayerName = (player: Player | undefined, name: string) => {
            if (!player) throw new Error(`Player not found`);
            setPlayerNameField(name);
            player.Name = name;
        }

        if (!player) return null;

        let color = player.Team.toLowerCase();
        if (draftType === DraftType.FFA) {
            color = PlayerNumberToColor(player.Number);
        }

        if(draftType === DraftType.Duel){
            color = PlayerNumberToColor(player.Number);
        }

        return (
            <div className={"melee-draft-card input " + color} >
                <div className='container'>
                    <input
                        type="text"
                        onChange={(e) => UpdatePlayerName(player, e.target.value)}
                        value={playerNameField}
                        placeholder={"Player " + player.Number}
                        key={`player-${player.Number}-name-input`}
                    />
                </div>
            </div>
        )
    }

    const TeamsForm = () => {
        return (
            <Grid className="player-form" columns={2} container stackable relaxed style={{ marginBottom: 24 }}>
                <Grid.Column>
                    <div style={basicMargin}>
                        <PlayerField
                            player={context!.players.find((p) => p.Number === 1)}
                        />
                    </div>
                    <div style={basicMargin}>
                        <PlayerField
                            player={context!.players.find((p) => p.Number === 2)}
                        />
                    </div>
                </Grid.Column>
                <Grid.Column>
                    <div style={basicMargin}>
                        <PlayerField
                            player={context!.players.find((p) => p.Number === 3)}
                        />
                    </div>
                    <div style={basicMargin}>
                        <PlayerField
                            player={context!.players.find((p) => p.Number === 4)}
                        />
                    </div>
                </Grid.Column>
            </Grid>
        )
    }

    const FFAForm = () => {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '2.5em',
                margin: '32px 0px 32px 0px'
            }}>
                <h5>Player 1 have highest seed, Player 4 lowest.</h5>
                <div style={playerFiledContainer}>
                    <PlayerField
                        player={context!.players.find((p) => p.Number === 1)}
                    />
                </div>
                <div style={playerFiledContainer}>
                    <PlayerField
                        player={context!.players.find((p) => p.Number === 2)}
                    />
                </div>
                <div style={playerFiledContainer}>
                    <PlayerField
                        player={context!.players.find((p) => p.Number === 3)}
                    />
                </div>
                <div style={playerFiledContainer}>
                    <PlayerField
                        player={context!.players.find((p) => p.Number === 4)}
                    />
                </div>
            </div>
        )
    }

    const FormToMode = () => {
        if (draftType === DraftType.Duel) {
            return <DuelForm PlayerField={PlayerField}/>
        }
        else if (draftType === DraftType.FFA) {
            return <FFAForm />
        }
        else {
            return <TeamsForm />
        }
    }

    return (
        <>
            <MeleeDashboard
                draftType={draftType}
                setDraftType={setDraftType}
            />
            {FormToMode()}
        </>
    )
}

const basicMargin = {
    margin: '16px 0px 16px 0px'
}

const playerFiledContainer = {
    maxWidth: '25em',
    margin: 'auto'
}

export default PlayerForm;